import _ from 'lodash'
import { iDataSchema, iDataSchemas } from '../builder/interfaces/iDataSchema'
import { calculateEnumPaths } from '../builder/utils/calculateEnumPaths'
import { ENV } from '../ENV'
import EnumLoader from '../services/EnumLoader'
import { findMappingPaths } from './convertor'

export const clearEnumsToVersion = async (
  data: any,
  formSchemaId: string,
  dataSchema: iDataSchemas,
) => {

  const enumsPaths = calculateEnumPaths(dataSchema)

  if (ENV.DEBUG_MODE) {
    console.log('CLEAR enums', { enumsPaths })
  }

  if (!enumsPaths?.length || !dataSchema) {
    return data
  }

  return await clearEnumsAll(data, formSchemaId, dataSchema, enumsPaths)
}

export const clearEnumsAll = async (
  data: any,
  formSchemaId: string,
  dataSchema: iDataSchemas,
  clearEnumPaths: string[],
) => {
  const allPromises: Promise<void>[] = []

  for (const clearEnumPath of clearEnumPaths) {
    const fromPaths = findMappingPaths(data, clearEnumPath)
    if (!fromPaths.length) {
      continue
    }
    const pathToSchema = clearEnumPath
      .replace(/\./g, '.properties.')
      .replace(/\.\[]\./g, '.items.')
      .replace(/\.properties\.items\./g, '.items.')

    const elDataSchema: iDataSchema = _.get(dataSchema, pathToSchema)
    const enumId = elDataSchema?.enum && 'key' in elDataSchema.enum ? elDataSchema.enum.key : ''

    if (ENV.DEBUG_MODE) {
      console.log('CLEAR enum', { fromPaths, pathToSchema, elDataSchema, enumId })
    }

    for (const path of fromPaths) {
      const formVal = _.get(data, path)

      if (formVal) {
        const promise = EnumLoader.getByCode(formSchemaId, enumId, formVal)
          .then(() => {})
          .catch(() => {
            _.unset(data, path)
          })

        allPromises.push(promise)
      }
    }
  }

  await Promise.all(allPromises)

  return data
}
